// extracted by mini-css-extract-plugin
export default {"root":"Badge__root___McKuk"};